import { Routes, Route } from 'react-router-dom';
import ChatApp from '../components/ChatApp/ChatApp';
import Home from '../components/Home/Home';
import Register from '../components/Register/Register';
import Login from '../components/Login/Login';
import PaymentForm from '../components/Payment/Payment';
import Profile from '../components/Profile/Profile';
import ForgotPassword from '../components/ForgotPassword/ForgotPassword';
import Success from '../components/Success/Success';
import LoginCode from '../components/Register/LoginCode';
import Subscription from '../components/Profile/Subscription';
import Unsubscribe from '../components/Unsubscribe/Unsubscribe';
import Storage from '../components/Storage/Storage'

const AppRoutes = ({ chatType }) => (
  <Routes>
    <Route path="/" element={<LoginCode />} />
    <Route path="/home" element={<Home />} />
    <Route path="/register" element={<Register />} />
    <Route path="/login" element={<LoginCode />} />
    <Route path="/fogotpassword" element={<ForgotPassword />} />
    <Route path="/chat" element={<ChatApp chatType={chatType} />} />
    <Route path="/payment" element={<PaymentForm />} />
    <Route path="/profile" element={<Profile />} />
    <Route path="/success" element={<Success />} />
    <Route path="/subscription" element={<Subscription />} />
    <Route path="/unsubscribe/:code" element={<Unsubscribe />} />
    <Route path="/storage" element={<Storage/>}/>
  </Routes>
);

export default AppRoutes;
